import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAngleDown,
  faAngleUp,
  faArchive,
  faArrowLeft,
  faArrowRight,
  faArrowsAlt,
  faArrowsRotate,
  faArrowsSplitUpAndLeft,
  faArrowUp,
  faArrowDown,
  faBackspace,
  faBan,
  faBars,
  faBell,
  faBellSlash,
  faBroom,
  faBusinessTime,
  faCalendar,
  faCalendarAlt,
  faCalendarPlus,
  faCamera,
  faChartArea,
  faChartPie,
  faCheck,
  faCheckCircle,
  faCircleCheck,
  faCheckDouble,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faCircleInfo,
  faCircleNotch,
  faCircleQuestion,
  faCircleUser,
  faClipboard,
  faClock,
  faCodeBranch,
  faCog,
  faCompressAlt,
  faCopy,
  faDesktop,
  faDownload,
  faEdit,
  faPenToSquare,
  faEllipsisH,
  faEllipsisV,
  faEnvelope,
  faExclamation,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faFile,
  faFileAlt,
  faFileContract,
  faFill,
  faFilter,
  faFingerprint,
  faFolder,
  faInbox,
  faInfo,
  faInfoCircle,
  faKey,
  faList,
  faListAlt,
  faListCheck,
  faLocationDot,
  faLock,
  faLongArrowAltLeft,
  faMailBulk,
  faMinus,
  faMinusCircle,
  faMobileAlt,
  faMoon,
  faPalette,
  faPaperPlane,
  faPaperclip,
  faPen,
  faPlus,
  faPlusSquare,
  faPrint,
  faQuestionCircle,
  faRedoAlt,
  faReply,
  faReplyAll,
  faSave,
  faSearch,
  faShare,
  faShareNodes,
  faSignOutAlt,
  faSignature,
  faSort,
  faSortAmountDown,
  faSortDown,
  faSortUp,
  faSpinner,
  faStar,
  faSync,
  faTable,
  faTableCellsLarge,
  faChartBar,
  faTag,
  faTags,
  faTrash,
  faTrashAlt,
  faUndoAlt,
  faUpDownLeftRight,
  faUpload,
  faUser,
  faUserCheck,
  faUserGroup,
  faUserPlus,
  faUserTie,
  faXmark,
  faAddressBook,
  faAddressCard,
  faBriefcase,
  faAt,
  faGlobe,
  faGripVertical,
  faLanguage
} from "@fortawesome/free-solid-svg-icons";

import {
  faBell as farBell,
  faClock as farClock,
  faEnvelope as farEnvelope,
  faEnvelopeOpen as farEnvelopeOpen,
  faFolder as farFolder,
  faPlusSquare as farPlusSquare,
  faStar as farStar,
  faTrashAlt as farTrashAlt,
  faPaperPlane as farPaperPlane,
  faAddressBook as farAddressBook,
  faListAlt as farListAlt,
  faEdit as farEdit,
  faEye as farEye,
  faUser as farUser,
  faCircleUser as farCircleUser,
  faAddressCard as farAddressCard,
  faChartBar as farChartBar,
  faCircleCheck as farCircleCheck,
  faCalendar as farCalendar
} from "@fortawesome/free-regular-svg-icons";

const faAutoAwesome = {
  prefix: "fas",
  iconName: "auto-awesome",
  icon: [
    24,
    24,
    [],
    "e001",
    "M19 9l1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25L19 9zm-10 11l-2.5-5.5L1 12l5.5-2.5L9 4l2.5 5.5L17 12l-5.5 2.5L9 20zm10 3l-1.25-2.75L15 19l2.75-1.25L19 15l1.25 2.75L23 19l-2.75 1.25L19 23z"
  ]
};

library.add(
  faAngleDown,
  faAngleUp,
  faArchive,
  faArrowLeft,
  faArrowRight,
  faArrowsAlt,
  faArrowsRotate,
  faArrowsSplitUpAndLeft,
  faArrowUp,
  faArrowDown,
  faBackspace,
  faBan,
  faBars,
  faBell,
  faBellSlash,
  faBroom,
  faBusinessTime,
  faCalendar,
  faCalendarAlt,
  faCalendarPlus,
  faCamera,
  faChartArea,
  faChartPie,
  faCheck,
  faCheckCircle,
  faCircleCheck,
  faCheckDouble,
  faChevronLeft,
  faChevronRight,
  faChevronDown,
  faCircleInfo,
  faCircleNotch,
  faCircleQuestion,
  faCircleUser,
  faClipboard,
  faClock,
  faCodeBranch,
  faCog,
  faCompressAlt,
  faCopy,
  faDesktop,
  faDownload,
  faEdit,
  faPenToSquare,
  faEllipsisH,
  faEllipsisV,
  faEnvelope,
  faExclamation,
  faExclamationCircle,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faFile,
  faFileAlt,
  faFileContract,
  faFill,
  faFilter,
  faFingerprint,
  faFolder,
  faInbox,
  faInfo,
  faInfoCircle,
  faKey,
  faList,
  faListAlt,
  faListCheck,
  faLocationDot,
  faLock,
  faLongArrowAltLeft,
  faMailBulk,
  faMinus,
  faMinusCircle,
  faMobileAlt,
  faMoon,
  faPalette,
  faPaperPlane,
  faPaperclip,
  faPen,
  faPlus,
  faPlusSquare,
  faPrint,
  faQuestionCircle,
  faRedoAlt,
  faReply,
  faReplyAll,
  faSave,
  faSearch,
  faShare,
  faShareNodes,
  faSignOutAlt,
  faSignature,
  faSort,
  faSortAmountDown,
  faSortDown,
  faSortUp,
  faSpinner,
  faStar,
  faSync,
  faTable,
  faTableCellsLarge,
  faChartBar,
  faTag,
  faTags,
  faTrash,
  faTrashAlt,
  faUndoAlt,
  faUpDownLeftRight,
  faUpload,
  faUser,
  faUserCheck,
  faUserGroup,
  faUserPlus,
  faUserTie,
  faAutoAwesome,
  faXmark,
  faAddressBook,
  faAddressCard,
  faBriefcase,
  faAt,
  faGlobe,
  faGripVertical,
  faLanguage,
  farBell,
  farClock,
  farEnvelope,
  farEnvelopeOpen,
  farFolder,
  farPlusSquare,
  farStar,
  farTrashAlt,
  farPaperPlane,
  farAddressBook,
  farListAlt,
  farEdit,
  farEye,
  farUser,
  farCircleUser,
  farAddressCard,
  farChartBar,
  farCircleCheck,
  farCalendar
);
